// Object containing a list of error codes and their
// corresponding error message.
export const errorMessages = {
  WRONG_PACKAGE: 'You are using the wrong package for this chart type. Change your package on FFonline.',
  EMPTY_CHART: 'The options you have selected produce an empty chart.',
};

export const defaultError = 'Please select different options';


// Returns specific error message if exists
// Returns default error message otherwise
export default (errorCode) => {
  if (/MISSING_[A-Za-z]+/.test(errorCode)) { // code matches format MISSING_[Param]
    return `${errorCode.split('MISSING_')[1]} must be provided for this chart.`;
  }
  return errorMessages[errorCode] || defaultError;
};

// NOTE: the chart currently produces a limited number of error codes and does not
//       attribute a usable error code to all errors.



// WEBPACK FOOTER //
// ./app/components/Chart/Errors/ErrorMessages.js